import { render } from "./DlBtn.vue?vue&type=template&id=20219e24&scoped=true"
import script from "./DlBtn.vue?vue&type=script&lang=js"
export * from "./DlBtn.vue?vue&type=script&lang=js"

import "./DlBtn.vue?vue&type=style&index=0&id=20219e24&scoped=true&lang=css"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20219e24"]])

export default __exports__